<!--  -->
<template>
  <div class="regbg">
    <div class="container">
        <h1 class="title">密码登陆</h1>
        <el-form label-position="top" label-width="80px" :model="formLabelAlign" style="margin-top:27px;" :rules="rules" ref="ruleForm">
            <input type="text" placeholder="请输入您的手机号" class="login loginuser" v-model="loginuser.account"/>
            <input type="password" placeholder="请输入您的密码" class="login loginpass" v-model="loginuser.password"/>
            <input type="text" placeholder="请输入您的验证码" class="login loginyzm" v-model="loginuser.yzcode"/>
             <img
                         style="width: 36%;
    height: 52px;"
                            :src="loginuser.yzmsrc"
                            @click="getImgVerify()"
                            alt="看不清?请点击刷新"
                            title="看不清?请点击刷新"
                            class="validate-code"
                            />
            <!-- <div></div> -->
            <el-checkbox v-model="checked" class="jizwo">记住我</el-checkbox>
            <div class="btnbox">
                <el-button type="primary"  class="regbtn" @click="submitForm()">登陆</el-button>
            </div>
            <p class="zucetip">还没有账号？<router-link to="/userreg">注册账号</router-link></p>
        </el-form>
    </div>  </div>
</template>

<script>
import {Message} from "element-ui";

import { loginUser} from '@/request/get'
import { IP_TEST } from "@/config";
export default {
  data () {
   
    return {
        webConfigs:{},
        global,
        checked: false,
        loginuser:{
            account:"",
            password:"",
            yzcode: "",
        }
    };
  },
    created(){
        this.getImgVerify()
        this.getCookie();
    },
  components: {},

  mounted(){},

  methods: {
    getImgVerify() {
      this.loginuser.yzmsrc =
        `${IP_TEST}/zhcpw/users/imgverify` + "?" + Math.random();
        this.$forceUpdate();
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.submitForm("loginForm");
      }
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "frontuserName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      if (c_pwd) {
        window.document.cookie =
          "frontuserPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      }
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "frontuserName") {
            this.loginuser.account = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "frontuserPwd") {
            this.loginuser.password = arr2[1];
            this.checked = true;
          }
        }
      }
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    async submitForm(){
        if(!this.loginuser.account)
        {
            Message.error("请输入您的用户名！");
            return;
        }
        if(!this.loginuser.password)
        {
            Message.error("请输入您的登陆密码！");
            return;
        }
        if(!this.loginuser.yzcode)
        {
            Message.error("请输入验证码！");
            return;
        }
        let result = await loginUser(this.loginuser);
        console.log(result);
        if(result.success)
        {
           // 登录成功
            const self = this;
            //判断复选框是否被勾选 勾选则调用配置cookie方法
            if (self.checked == true) {
              //传入账号名，密码，和保存天数3个参数
              self.setCookie(this.loginuser.account, this.loginuser.password, 30);
            } else {
              console.log("清空Cookie");
              //清空Cookie
              self.clearCookie();
              self.setCookie(this.loginuser.account, "", 30);
            }
            const { user } = result.data;
            localStorage.setItem("eleTokensxwf001", user);
            localStorage.setItem("eleTokensxwfuser001", JSON.stringify(result.data));
            // 解析token
            // 存储数据
            this.$store.dispatch("setIsAutnenticated", true);
            this.$store.dispatch("setUser", user);
            // 页面跳转
            this.$router.push("/")
        }else{
           Message.error(result.data.error);
        }
    }
  }
}

</script>
<style scoped>
.regbg{
    background-image: url(/static/img/bg_denglu.png);
    width: 100%;
    /* height: 100vh; */
    background-repeat: no-repeat;
}
.headcls{
    width: 1300px;
    margin: 0 auto;
    padding: 32px 0px;
    position: relative;
}
.imgbox{
    display: inline-block;
}
.fuwubox{
    display: inline-block;
    position: absolute;
    right: 0;
}
.fuwubox p{
        font-size: 20px;
  
    font-weight: 500;
    color: #347CE4;
    line-height: 31px;
    letter-spacing: 15px;
}
.fuwubox img {
    margin-right: 20px;
}
.fuwubox span{
    font-size: 28px;
font-family: Source Han Sans CN;
font-weight: bold;
color: #347CE4;
/* margin-top:19px; */
letter-spacing: 4px;
line-height: 46px;
}
.container{
width: 500px;
    height: 406px;
    background: #FFFFFF;
    -webkit-box-shadow: 0px 2px 24px 0px rgb(215 223 242 / 93%);
    box-shadow: 0px 2px 24px 0px rgb(215 223 242 / 93%);
    opacity: 0.76;
    border-radius: 10px;
    padding: 62px 28px 38px 28px;
    margin-top:50px ;
}
.title {
    font-size: 26px;
  
    font-weight: bold;
    color: #333333;
    letter-spacing: 10px;
    text-align: center;
}
.description{
    font-size: 20px;
font-family: PingFang SC;
font-weight: 500;
color: #999999;
    text-align: center;
    margin-top:33px;
}
/deep/ .el-form--label-top .el-form-item__label{
    font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
}
/deep/ .el-input__inner{
    width: 355px;
height: 47px;
border: 1px solid #D9D9D9;
border-radius: 6px !important;
}
.regbtn{
    width: 477px;
    height: 66px;
    background: #347CE4;
    border-radius: 6px;
    font-size: 24px;
  
    font-weight: 500;
    color: #FFFFFF;
    opacity: 1;
    letter-spacing: 3px;
}
.btnbox{
    width: 100%;
    text-align: center;
    margin-top:30px;
        opacity: 1;
}
.regtip{
    text-align: center;
    font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333;
margin-top:38px;
}
.wzright{
    font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #ffffff;
/* position: absolute; */
text-align: center;
margin-top:95px;
/* bottom: 16px; */
}
.login{
display: block;
    width: 420px;
    height: 52px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    margin: auto;
    margin-bottom: 20px;
    font-size: 16px;
  
    font-weight: 500;
    color: #000000;
    padding-left: 54px;
    background-position-x: 10px;
    background-position-y: 19px;
}
.loginuser{
    background-image: url(/static/img/icon_yonghu.png);
    background-repeat: no-repeat;
}
.loginpass{
    background-image: url(/static/img/icon_suo.png);
    background-repeat: no-repeat;
}
.loginyzm{
    background-image: url(/static/img/icon_suo.png);
    background-repeat: no-repeat;
   
}
.zucetip{
    font-size: 15px;
  
    font-weight: 500;
    color: #333;
    margin: 20px 0 0 13px;
}
.zucetip a{
   color:  #4B9D52;
  
}
.jizwo{
font-size: 14px;
  
    font-weight: 500;
    color: #333;
    margin-left: 15px;
}
.loginyzm{
  width: 52%;
    position: relative;
    left: 12px;
    display: inline-block;
}
</style>